import React from 'react';
import DashboardLayout from '@/layouts/DashboardLayout';
import { ProfileEditor } from '@/components/profile/ProfileEditor';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

const Settings: React.FC = () => {
  return (
    <DashboardLayout>
      <div className="container max-w-4xl mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold">Settings</h1>
          <p className="text-muted-foreground mt-1">
            Manage your profile and preferences
          </p>
        </div>

        <Tabs defaultValue="profile" className="space-y-6">
          <TabsList>
            <TabsTrigger value="profile">Profile</TabsTrigger>
            <TabsTrigger value="account">Account</TabsTrigger>
            <TabsTrigger value="notifications">Notifications</TabsTrigger>
            <TabsTrigger value="integrations">Integrations</TabsTrigger>
          </TabsList>

          <TabsContent value="profile">
            <ProfileEditor />
          </TabsContent>

          <TabsContent value="account">
            <div className="text-center text-muted-foreground py-8">
              Account settings coming soon
            </div>
          </TabsContent>

          <TabsContent value="notifications">
            <div className="text-center text-muted-foreground py-8">
              Notification preferences coming soon
            </div>
          </TabsContent>

          <TabsContent value="integrations">
            <div className="text-center text-muted-foreground py-8">
              Integration settings coming soon
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </DashboardLayout>
  );
};

export default Settings;
